<div class="container">
    <div class="row flex-column-reverse flex-md-row">
        <div class="col-md-6 my-auto">
            <h2>Hi, {{greetUser}}</h2>
            <h2 style="font-weight: 200;">I'm Nagarajan</h2>
            <span class="greet-element"></span>
        </div>
        <div class="col-md-6">
            <img src="assets/images/about.png" width="100%" alt="about">
        </div>
    </div>
</div>